import { Paper, Typography } from '@mui/material'
import * as Sentry from '@sentry/react'
import type { ErrorComponentProps } from '@tanstack/react-router'
import axios from 'axios'
import { useEffect } from 'react'
import { getApiErrorMessage } from '~/lib/utils'
import { fonts } from '../../utils/theme/fonts.theme'
import Center from '../containers/Center'

const ErrorComponent = ({ error }: ErrorComponentProps) => {
  // Une erreur hors client axios (exception de l'écran, appel Tuyau) part à Sentry, une fois.
  useEffect(() => {
    if (!axios.isAxiosError(error)) Sentry.captureException(error)
  }, [error])

  return (
    <Center style={{ height: '100vh', padding: '5%' }}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Typography style={fonts.pageTitle}>ERREUR</Typography>
        <Typography style={fonts.inputHeader}>{getApiErrorMessage(error)}</Typography>
        {error instanceof Error && error.stack && (
          <Paper elevation={5} style={{ marginTop: '5%', padding: '30px', borderRadius: '10px' }}>
            <Typography style={fonts.informationSubText}>{error.stack}</Typography>
          </Paper>
        )}
      </div>
    </Center>
  )
}

export default ErrorComponent
